// import { useEffect, useState } from "react";
// import { getRoom, updateRoom } from "../services/roomService";
// import { useParams, useNavigate } from "react-router-dom";

// export default function EditRoom() {
//   const { id } = useParams();
//   const navigate = useNavigate();

//   const [room, setRoom] = useState(null);

//   useEffect(() => {
//     getRoom(id).then((res) => setRoom(res.data));
//   }, [id]);

//   const convertToBase64 = (file) => {
//     const reader = new FileReader();
//     reader.onloadend = () =>
//       setRoom({ ...room, image: reader.result.split(",")[1] });
//     reader.readAsDataURL(file);
//   };

//   const handleSave = async (e) => {
//     e.preventDefault();
//     await updateRoom(id, room);
//     navigate("/admin/manage-rooms");
//   };

//   if (!room) return <p>Loading...</p>;

//   return (
//     <div className="p-6 max-w-lg mx-auto">
//       <h2 className="text-2xl mb-4">Edit Room</h2>

//       <form onSubmit={handleSave} className="flex flex-col gap-4">
//         <input
//           className="border p-2"
//           value={room.roomNumber}
//           onChange={(e) =>
//             setRoom({ ...room, roomNumber: e.target.value })
//           }
//         />

//         <input
//           className="border p-2"
//           value={room.roomType}
//           onChange={(e) =>
//             setRoom({ ...room, roomType: e.target.value })
//           }
//         />

//         <input
//           type="number"
//           className="border p-2"
//           value={room.price}
//           onChange={(e) => setRoom({ ...room, price: e.target.value })}
//         />

//         <input
//           type="number"
//           className="border p-2"
//           value={room.capacity}
//           onChange={(e) =>
//             setRoom({ ...room, capacity: e.target.value })
//           }
//         />

//         <textarea
//           className="border p-2"
//           value={room.description}
//           onChange={(e) =>
//             setRoom({ ...room, description: e.target.value })
//           }
//         />

//         <p>Current Image:</p>
//         <img
//           src={`data:image/jpeg;base64,${room.image}`}
//           className="w-40"
//         />

//         <input type="file" onChange={(e) => convertToBase64(e.target.files[0])} />

//         <button className="bg-blue-600 text-white p-2 rounded">Save</button>
//       </form>
//     </div>
//   );
// }


// import { useEffect, useState } from "react";
// import { getRoomById, editRoom,getRooms } from "../services/roomService";
// import { useParams, useNavigate } from "react-router-dom";

// export default function EditRoom() {
//   const { id } = useParams();
//   const navigate = useNavigate();

//   const [room, setRoom] = useState(null);
//   const [image, setImage] = useState("");

//   useEffect(() => {
//     getRooms().then((rooms) => {
//       const found = rooms.find((r) => r.id == id);
//       setRoom(found);
//       setImage(found.image);
//     });
//   }, [id]);



//   useEffect(() => {
//     loadRoom();
//   }, []);

//   const loadRoom = async () => {
//     try {
//       const res = await getRoomById(id);
//       setRoom(res.data); // Backend returns single room object
//     } catch (error) {
//       console.error("Error fetching room:", error);
//     }
//   };



//   const convertBase64 = (file) => {
//     const reader = new FileReader();
//     reader.onloadend = () => setImage(reader.result);
//     reader.readAsDataURL(file);
//   };

//   const handleSave = async (e) => {
//     e.preventDefault();
//     await editRoom(id, { ...room, image });
//     navigate("/admin/manage-rooms");
//   };

//   if (!room) return <p>Loading...</p>;

//   return (
//     <div className="p-4">
//       <h2>Edit Room</h2>

//       <form onSubmit={handleSave}>
//         <input
//           className="form-control"
//           value={room.roomNumber}
//           onChange={(e) => setRoom({ ...room, roomNumber: e.target.value })}
//         />

//         <input
//           className="form-control mt-2"
//           value={room.roomType}
//           onChange={(e) => setRoom({ ...room, roomType: e.target.value })}
//         />

//         <input
//           className="form-control mt-2"
//           value={room.price}
//           onChange={(e) => setRoom({ ...room, price: e.target.value })}
//         />

//         <input
//           className="form-control mt-2"
//           value={room.capacity}
//           onChange={(e) => setRoom({ ...room, capacity: e.target.value })}
//         />

//         <input
//           className="form-control mt-2"
//           value={room.name}
//           onChange={(e) => setRoom({ ...room, name: e.target.value })}
//         />

//         <textarea
//           className="form-control mt-2"
//           value={room.description}
//           onChange={(e) => setRoom({ ...room, description: e.target.value })}
//         />

//         <p>Current Image:</p>
//         <img src={image} width="120" className="mb-2" />

//         <input type="file" onChange={(e) => convertBase64(e.target.files[0])} />

//         <button className="btn btn-primary mt-3">Save</button>
//       </form>
//     </div>
//   );
// }


import { useEffect, useState } from "react";
import { getRoomById, editRoom } from "../services/roomService";
import { useParams, useNavigate } from "react-router-dom";

export default function EditRoom() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [room, setRoom] = useState(null);
  const [image, setImage] = useState("");

  useEffect(() => {
    loadRoom();
  }, [id]);

  const loadRoom = async () => {
    try {
      const res = await getRoomById(id);
      setRoom(res.data);
      setImage(res.data.image);
    } catch (error) {
      console.error("Error fetching room:", error);
    }
  };

  const convertBase64 = (file) => {
    const reader = new FileReader();
    reader.onloadend = () => setImage(reader.result);
    reader.readAsDataURL(file);
  };

  const handleSave = async (e) => {
    e.preventDefault();
    await editRoom({ ...room, id, image });
    navigate("/admin/manage-rooms");
  };

  if (!room) return <p>Loading...</p>;

  return (
    <div className="p-4">
      <h2>Edit Room</h2>

      <form onSubmit={handleSave}>
        <input
          className="form-control"
          value={room.roomNumber}
          onChange={(e) => setRoom({ ...room, roomNumber: e.target.value })}
        />

        <input
          className="form-control mt-2"
          value={room.roomType}
          onChange={(e) => setRoom({ ...room, roomType: e.target.value })}
        />

        <input
          className="form-control mt-2"
          value={room.price}
          onChange={(e) => setRoom({ ...room, price: e.target.value })}
        />

        <input
          className="form-control mt-2"
          value={room.capacity}
          onChange={(e) => setRoom({ ...room, capacity: e.target.value })}
        />

        <input
          className="form-control mt-2"
          value={room.name}
          onChange={(e) => setRoom({ ...room, name: e.target.value })}
        />

        <textarea
          className="form-control mt-2"
          value={room.description}
          onChange={(e) => setRoom({ ...room, description: e.target.value })}
        />

        <p>Current Image:</p>
        <img src={image} width="120" className="mb-2" />

        <input type="file" onChange={(e) => convertBase64(e.target.files[0])} />

        <button className="btn btn-primary mt-3">Save</button>
      </form>
    </div>
  );
}
